import { useSelector } from 'react-redux'
import type { Constant } from '@pbt/pbt-ui-components'

import TimeUnitsSelect, {
  type TimeUnitsSelectProps,
} from '~/components/common/TimeUnitsSelect'
import { getAppointmentCommunicationTimeUnits } from '~/store/reducers/constants'

const AppointmentCommunicationTimeUnitsSelect = ({
  amount,
  ...rest
}: TimeUnitsSelectProps) => {
  const AppointmentCommunicationTimeUnits: Constant[] = useSelector(
    getAppointmentCommunicationTimeUnits,
  )

  return (
    <TimeUnitsSelect
      amount={Number(amount)}
      items={AppointmentCommunicationTimeUnits}
      {...rest}
    />
  )
}

export default AppointmentCommunicationTimeUnitsSelect
